import { render } from "./TopBar.vue?vue&type=template&id=91083044&scoped=true"
const script = {}

import "./TopBar.vue?vue&type=style&index=0&id=91083044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91083044"]])

export default __exports__